import { Check } from "lucide-react";

// Edge-to-edge scrolling strip. Children are duplicated so the loop is seamless.
export const Marquee = ({ items, tone = "plum", speed = "", reverse = false, testId }) => {
  const tones = {
    plum: "mbm-gradient text-white",
    butter: "bg-amber text-cocoa",
    cream: "bg-creamDeep text-cocoa",
  };
  return (
    <div
      data-testid={testId}
      className={`relative overflow-hidden py-4 ${tones[tone]}`}
      aria-hidden="true"
    >
      <div className={`mbm-marquee ${speed} ${reverse ? "mbm-marquee-reverse" : ""}`}>
        {[0, 1].map((copy) => (
          <ul key={copy} className="flex shrink-0 items-center">
            {items.map((item) => (
              <li
                key={`${copy}-${item}`}
                className="flex shrink-0 items-center gap-2.5 px-6 text-sm font-extrabold sm:text-[15px]"
              >
                <Check
                  className={`h-4 w-4 shrink-0 ${tone === "plum" ? "text-white" : "text-coralInk"}`}
                />
                {item}
              </li>
            ))}
          </ul>
        ))}
      </div>
    </div>
  );
};

// "No ___" chip strip used on the standards band.
export const NoMarquee = ({ items, reverse = false }) => (
  <div className="relative overflow-hidden py-2.5" aria-hidden="true">
    <div className={`mbm-marquee mbm-marquee-fast ${reverse ? "mbm-marquee-reverse" : ""}`}>
      {[0, 1].map((copy) => (
        <ul key={copy} className="flex shrink-0 items-center">
          {items.map((item) => (
            <li key={`${copy}-${item}`} className="shrink-0 px-2">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-surface px-4 py-2.5 text-sm font-bold text-cocoa shadow-soft">
                <span className="font-heading text-base font-black text-coralInk">No</span>
                {item}
              </span>
            </li>
          ))}
        </ul>
      ))}
    </div>
  </div>
);

export default Marquee;
